import { EVENT_FORMS, VIOLATION_FORMS } from '../../utils/pluralRu';

/*
 * Словарь полей и текстов блоков «Сводки». Вкладки «Нарушения» и
 * «Бизнес-метрики» рисуются одними компонентами и различаются только
 * подписями и тем, оценивается ли рост цветом.
 *
 * BM-FE-TZ-002C: /analytics/business-summary отдаёт тот же
 * ExecutiveSummaryResponse с legacy-именами violations_* — business_* полей
 * нет. Поэтому ключи полей у обоих словарей одинаковые.
 */

const FIELD_KEYS = {
  countKey: 'violations_count',
  previousCountKey: 'previous_violations_count',
  previousPreviousCountKey: 'previous_previous_violations_count',
  durationKey: 'violation_duration_seconds',
  maxDurationKey: 'max_violation_duration_seconds',
  rateKey: 'violations_per_100_control_hours',
  previousRateKey: 'previous_violations_per_100_control_hours',
  changeDirectionKey: 'violations_change_direction',
  changePercentKey: 'violations_change_percent',
};

export const VIOLATION_VOCAB = {
  ...FIELD_KEYS,
  kind: 'violation',
  unitForms: VIOLATION_FORMS,
  countTitle: 'Нарушения',
  emptyText: 'За период нарушений нет',
  newText: 'В прошлом периоде нарушений не было',
  trendTitle: 'Динамика нарушений',
  heatmapTitle: 'Когда происходят нарушения',
  distributionTitle: 'Распределение по нарушениям',
  // Рост нарушений плох — красным.
  growthIs: 'down',
};

export const BUSINESS_VOCAB = {
  ...FIELD_KEYS,
  kind: 'business',
  unitForms: EVENT_FORMS,
  countTitle: 'Бизнес-события',
  emptyText: 'За период бизнес-событий нет',
  newText: 'В прошлом периоде бизнес-событий не было',
  trendTitle: 'Динамика бизнес-событий',
  heatmapTitle: 'Когда происходят бизнес-события',
  distributionTitle: 'Распределение бизнес-событий',
  // Рост бизнес-событий сам по себе ни хорош, ни плох — без оценки цветом.
  growthIs: 'none',
};

export const vocabForKind = (kind) => (kind === 'business' ? BUSINESS_VOCAB : VIOLATION_VOCAB);
